import styled from 'styled-components';

// Fase 3 nav Trabajo/Revisión (rework, 2026-07-12) — reutiliza el `Container`
// compartido de workOrders (mismo patrón que `GeneralView/styles.ts`
// `ContainerStyled` y `CampaignDetailed/styles.ts`, wrappers Tabs+Outlet
// hermanos) en vez de reinventar un contenedor propio.
import { Container } from '../../workOrders/components/MainStyledComponents';

export const ContainerStyled = styled(Container)`
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.spaces.s}rem;
`;
